import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './actions';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';

export type FireInsuranceBrokerageSearchStateModel = AlgoliaBaseState<unknown>;

@State<FireInsuranceBrokerageSearchStateModel>({
	name: 'fireInsuranceBrokeragesSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class FireInsuranceBrokeragesSearchState extends AlgoliaSearchState<FireInsuranceBrokerageSearchStateModel> {
	protected indexName = getIndex(IndexType.FIRE_INSURANCE_BROKERAGES);

	@Selector([FireInsuranceBrokeragesSearchState])
	static getList(state: FireInsuranceBrokerageSearchStateModel): unknown[] {
		return state?.items;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<FireInsuranceBrokerageSearchStateModel>,
		{ searchTerm }: actions.Search,
	): Promise<void> {
		await this.algoliaSearchHandler(ctx, searchTerm);
	}
}
